import GlobalStyle from '@reactjscomponentrepository/frontend-components/lib/styles/globalStyles';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Router } from './Router';

function App() {
  return (
    <>
      <GlobalStyle />
      <ToastContainer position="top-right" theme='colored' />
      <Router />
    </>
  );
}

export default App;
